import cloudAdvantageAnimation from "assets/animations/cloudAdvantage.json";
import interfacePersonalizationAdvantageAnimation from "assets/animations/interfacePersonalizationAdvantage.json";
import paymentsAdvantageAnimation from "assets/animations/paymentsAdvantage.json";
import profitabilityAdvantageAnimation from "assets/animations/profitabilityAdvantage.json";
import servicesIntegrationAdvantageAnimation from "assets/animations/servicesIntegrationAdvantage.json";
import sustainabilityAdvantageAnimation from "assets/animations/sustainabilityAdvantage.json";
import FullPageContainer from "components/FullPageContainer";
import { IntersectionObserverOptions } from "hooks/useIntersectionObserver";
import useOnScreen from "hooks/useOnScreen";
import React, { useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import Advantage, { AdvantageInterface } from "./Advantage";
import {
  AdvantagesContainer,
  StyledContentContainer,
  StyledHeading,
} from "./styles";

const intersectionOptions: IntersectionObserverOptions = {
  threshold: 0.1,
  unobserveOnIntersection: true,
};

const Advantages: React.FC = () => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const isSectionVisible = useOnScreen(containerRef, intersectionOptions);

  const advantages = useMemo<Array<AdvantageInterface>>(
    () => [
      {
        animationData: sustainabilityAdvantageAnimation,
        title: t("10192") /* Sustentabilidade */,
        body: t("10193") /* 100% Energia Solar e Tickets Virtuais */,
        ariaLabel: t("10707") /* Energia Solar e tickets virtuais */,
      },
      {
        animationData: cloudAdvantageAnimation,
        title: "Cloud",
        body: t("10194") /* Solução alojada na cloud e disponível 24h */,
        ariaLabel:
          t("10708") /* Solução alojada na cloud e sempre disponível */,
      },
      {
        animationData: profitabilityAdvantageAnimation,
        title: t("10195") /* Rentabilização */,
        body: t(
          "10196"
        ) /* Publicidade Geolocalizada, que possibilita uma entrega de publicidade segmentada demograficamente */,
        ariaLabel: t("10709") /* Publicidade segmentada demograficamente */,
      },
      {
        animationData: interfacePersonalizationAdvantageAnimation,
        title: t("10197") /* Interface e Personalização */,
        body: t(
          "10198"
        ) /* Touch screen com ecrã de alta qualidade e capacidade de personalizar o seu parquímetro */,
        ariaLabel:
          t(
            "10710"
          ) /* Touch sreen de alta qualidade e personalização do parquímetro */,
      },
      {
        animationData: servicesIntegrationAdvantageAnimation,
        title: t("10199") /* Integração de Serviços */,
        body: t(
          "10200"
        ) /* Transportes, Pagamentos de Serviços Municipais, de Avisos e Eventos Culturais */,
        ariaLabel: t("10711") /* Pagamento de outros serviços personalizados */,
      },
      {
        animationData: paymentsAdvantageAnimation,
        title: t("3435") /* Pagamentos */,
        body: t("10201") /* Moedas, Voucher, Cartões Bancários e MB WAY */,
        ariaLabel:
          t(
            "10712"
          ) /* Pagamento com moedas, voucher, cartão bancário e MB WAY */,
      },
    ],
    [t]
  );

  return (
    <section aria-labelledby="advantages-heading">
      <FullPageContainer id="modules">
        <StyledContentContainer ref={containerRef}>
          <StyledHeading
            elementType="h2"
            color="secondary"
            isSectionVisible={isSectionVisible}
            id="advantages-heading"
          >
            <p>{t("10191") /* Vantagens */}</p>
            <p>iParque Street</p>
          </StyledHeading>
          <AdvantagesContainer>
            {advantages.map((advantage, index) => (
              <Advantage
                key={advantage.title}
                index={index}
                isSectionVisible={isSectionVisible}
                {...advantage}
              />
            ))}
          </AdvantagesContainer>
        </StyledContentContainer>
      </FullPageContainer>
    </section>
  );
};

export default Advantages;
